import React from 'react'
import { Link } from 'react-router-dom'
import { cn } from '../../lib/utils'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  linkClassName?: string
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  className,
  linkClassName 
}) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  }

  return (
    <Link 
      to="/" 
      className={cn("flex items-center", linkClassName)}
    >
      <img
        src="/images/KiraCar-logo-icon80.png"
        alt="KiraCar"
        className={cn(
          "object-contain",
          sizeClasses[size],
          className
        )}
      />
    </Link>
  )
}

export default Logo 